var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5203_11315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31842 8.14052L2.48063 2.00391L4.24727 2.79421V7.06019L1.31842 8.14052Z",
    fill: "#67CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58354 8.93075L3.07408 10.279L1.35394 8.14045L7.58354 6.23438V8.93075Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14257 22.043L4.00408 23.5307H1.12173L0.563843 22.1825L3.35321 20.7656L6.14257 22.043Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51636 15.3477L4.00403 23.5298L6.14252 22.0422L5.49509 17.4542L2.51636 15.3477Z",
    fill: "#67CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53626 17.8583L7.1188 18.6486L2.51636 15.3479L4.05048 13.4883L8.69946 15.1619L9.53626 17.8583Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5941 8.14052L21.4319 2.00391L19.6653 2.79421V7.01915L22.5941 8.14052Z",
    fill: "#67CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4166 8.93075L20.9261 10.279L22.6462 8.14045L16.4166 6.23438V8.93075Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.858 22.043L19.9965 23.5307H22.8788L23.4367 22.1825L20.6473 20.7656L17.858 22.043Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4841 15.3477L19.9965 23.5298L17.858 22.0422L18.5054 17.4542L21.4841 15.3477Z",
    fill: "#67CCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4224 15.1182L19.9499 13.4883L21.484 15.3479L16.8816 18.6486L14.4641 17.8583L15.4224 15.1182Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87791 4.56905L6.92798 2.84195L7.67184 1.44727L9.71739 1.72618L7.87791 4.56905Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.978 4.56905L16.928 2.84195L16.1841 1.44727L14.1386 1.72618L15.978 4.56905Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.464 17.8578L16.4166 11.7212V5.39861L13.3018 0.470703H10.6984L7.58356 5.39861V11.7212L9.53612 17.8578H14.464Z",
    fill: "#B1D952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4005 14.9137L14.464 17.8577H9.53603L7.58356 11.7208V5.39845L9.68473 2.07422C9.21415 3.2554 8.95062 4.57916 8.95062 5.97775C8.95062 10.5425 11.7577 14.3152 15.4005 14.9137Z",
    fill: "#91B706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.354 8.14052L2.51626 2.00391L4.28285 2.79421V7.06019",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51624 15.3477L4.00391 23.5298",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47807 17.6133L6.14245 22.0424L4.00396 23.5301H1.1216L0.563721 22.1819L3.35309 20.765",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6463 8.14052L21.484 2.00391L19.7174 2.79421V7.01915",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.484 15.3477L19.9963 23.5298",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5112 17.6855L17.8578 22.0415L19.9963 23.5291H22.8787L23.4366 22.1809L20.6472 20.7641",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02213 4.56905L7.0722 2.84195L7.81606 1.44727L9.86157 1.72618",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9781 4.56905L16.928 2.84195L16.1842 1.44727L14.1387 1.72618",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5836 8.9327L3.07415 10.2809L1.354 8.1424L7.5836 6.23633",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53614 17.8583L7.11868 18.6486L2.51624 15.3479L4.05035 13.4883L8.69934 15.1619",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4641 17.8578L16.4167 11.7212V5.39861L13.3018 0.470703H10.6984L7.58362 5.39861V11.7212L9.53618 17.8578H14.4641Z",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4166 8.9327L20.9261 10.2809L22.6462 8.1424L16.4166 6.23633",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4224 15.1182L19.9499 13.4883L21.484 15.3479L16.8816 18.6486L14.4641 17.8583",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5203_11315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon2);
export default __webpack_public_path__ + "static/media/assistant-icon-2.f4d38e21a4a47c5203a17b7d1cd1228c.svg";
export { ForwardRef as ReactComponent };